export default __webpack_public_path__ + "static/CookieRunBold.subset.5-a3b8b1b1a565433379a08021fbeac8c5.otf";